var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "assignClient" },
    [
      _c(
        "v-card-title",
        { staticStyle: { height: "48px", "flex-wrap": "nowrap" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c("v-flex", [
                _c("span", { staticClass: "roomName" }, [
                  _vm._v(
                    "Move Client to Room: " +
                      _vm._s(_vm.moveParams.toValues.roomName)
                  )
                ])
              ])
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { xs: "", icon: "", flat: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.handleCancel()
                }
              }
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { staticClass: "detailsRow", attrs: { row: "" } },
            [
              _c("v-flex", [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("Move Client")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(
                    _vm._s(
                      _vm.moveParams.fromValues.clientName.first +
                        " " +
                        _vm.moveParams.fromValues.clientName.last
                    )
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "v-layout",
            { staticClass: "detailsRow", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("From Room")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.moveParams.fromValues.roomName))
                ])
              ]),
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("From Bed")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.moveParams.fromValues.bedName))
                ])
              ])
            ],
            1
          ),
          _c(
            "v-layout",
            { staticClass: "detailsRow", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs6: "" } }, [
                _c("div", { staticClass: "ntstValueLabel" }, [
                  _vm._v("To Room")
                ]),
                _c("div", { staticClass: "ntstValue" }, [
                  _vm._v(_vm._s(_vm.moveParams.toValues.roomName))
                ])
              ]),
              _c(
                "v-flex",
                { attrs: { xs6: "" } },
                [
                  _c("div", { staticClass: "ntstValueLabel" }, [
                    _vm._v("To Bed")
                  ]),
                  _vm.isEditable
                    ? _c("v-select", {
                        staticClass: "bedSelector ntstValue",
                        staticStyle: { width: "160px" },
                        attrs: {
                          disabled: !_vm.isEditable,
                          items: _vm.bedList(_vm.moveParams),
                          "item-value": "bedBoardBedID.id",
                          outline: "",
                          "item-text": "name"
                        },
                        model: {
                          value: _vm.moveParams.toValues.bedID.id,
                          callback: function($$v) {
                            _vm.$set(_vm.moveParams.toValues.bedID, "id", $$v)
                          },
                          expression: "moveParams.toValues.bedID.id"
                        }
                      })
                    : _vm._e(),
                  !_vm.isEditable
                    ? _c("div", [
                        _vm._v(_vm._s(_vm.moveParams.toValues.bedName))
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "ntstAppButton",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.handleCancel()
                }
              }
            },
            [_vm._v("\n      Cancel\n    ")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "ntstAppButton",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.handleMove()
                }
              }
            },
            [_vm._v("\n      Move\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }